import Vue from 'vue'
import { api } from '@/services/api'
import { normalizarTexto } from '@/utils/normalizar'

/**
 * Concessionárias ativas, carregadas da API (GET energy/concessionarias).
 * Cada item: { id, nome, uf, cnpj, total (R$/MWh), aliases }.
 * Array reativo preenchido no lugar — quem importa CONCESSIONARIAS enxerga a carga.
 */
export const CONCESSIONARIAS = Vue.observable([])

let carregando = null

/**
 * Carrega a lista uma única vez; em caso de falha libera para tentar de novo.
 */
export function carregarConcessionarias() {
  if (CONCESSIONARIAS.length > 0) return Promise.resolve(CONCESSIONARIAS)
  if (carregando) return carregando

  carregando = api.get('energy/concessionarias')
    .then(({ data }) => {
      const lista = data && data.status === 'success' && Array.isArray(data.list) ? data.list : []
      CONCESSIONARIAS.splice(0, CONCESSIONARIAS.length, ...lista.map(c => ({
        id: c.id,
        nome: c.name,
        uf: c.state,
        cnpj: c.cnpj,
        total: Number(c.tariff) || 0,
        aliases: Array.isArray(c.aliases) ? c.aliases : [],
      })))
      return CONCESSIONARIAS
    })
    .finally(() => { carregando = null })

  return carregando
}

/**
 * Identifica a concessionária pelo texto da conta (nome ou alias).
 * Em caso de mais de um match, vence o texto candidato mais longo (mais específico).
 */
export function matchConcessionaria(texto) {
  const alvo = normalizarTexto(texto)
  if (!alvo) return null

  let melhor = null
  let melhorTamanho = 0

  for (const c of CONCESSIONARIAS) {
    for (const candidato of [c.nome, ...(c.aliases || [])].map(normalizarTexto)) {
      if (!candidato) continue
      if ((alvo.includes(candidato) || candidato.includes(alvo)) && candidato.length > melhorTamanho) {
        melhorTamanho = candidato.length
        melhor = c
      }
    }
  }

  return melhor
}
